
import React, { useState, useRef, useEffect } from "react";
import deptcse from "../../assets/Department/deptcse.jpg";
import AcadCalendar from "../../Components/Academics/AcadCalender"
import SidebarGalleryPage from "../../Components/Main/Sidebargallery"
import axios from "axios";
import { toast } from "react-toastify";
import {Link} from "react-router-dom";
import NewsFeed from "../Home/News";
import LaboratoryDetails from "../LaboratoryDetails/laboratoryDetails";
import DeptNewsLetter from "../DeptNewsLetter/NewsLetter";

const Deptcse = () => {

  // Faculty data

  const [staff, setStaff] = useState([]);

  // Fetch staff data from API
  useEffect(() => {
    const fetchStaff = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/v1/staff`
        );
        setStaff(response.data.staff);
        // console.log("Dharma",response);
      } catch (error) {
        console.error("Error fetching staff:", error);
        toast.error("Failed to fetch staff data.");
      }
    };

    fetchStaff();
  }, []);


  const containers = [
    {
      title: "Introduction",
      content: (
        <>
          <p className="p-2">
            The Department of Computer Engineering was started in the year 2006
            to provide quality diploma programme to the Women student aspirants
            of Madhya Pradesh. The Department offers 3-year Diploma Programme in
            Computer science and Engineering approved by AICTE, New Delhi and
            affiliated to RGPV Bhopal, Madhya Pradesh.
          </p>
          <p className="p-2">
            The Department imparts excellent knowledge to the students in the
            field of Computer Engineering as per the latest syllabus prescribed
            by RGPV which is being updated at regular intervals.
          </p>
          <p className="p-2">
            The Department educates the learners with the best teaching-learning
            practices by experienced faculty members with the support of
            state-of-art infrastructure.
          </p>
          <p className="p-2">
            The Department also conducts seminars and workshops to the students
            by inviting Academicians from reputed Institutions and
            Industrialists from renowned Companies to offer latest innovative
            technologies in the field of Computer Science and Engineering.
            Students undergo in-plant training during a vacation in Companies
            and Industries to have hands-on experience in the work environment.
          </p>
        </>
      ),
    },
    {
      title: "Programme Educational Objectives",
      content: (
        <ol className="p-6 text-gray-700 list-decimal">
          <li>Develop and maintain software systems and networks.</li>
          <li>
            Develop a life-long learning attitude towards the latest trends in
            market-driven technology.
          </li>
          <li>
            Demonstrate professional skills through: Effective communication,
            Teamwork,A multidisciplinary approach, and Ethical behavior.
          </li>
        </ol>
      ),
    },
    {
      title: "Programme Outcomes",
      content: (
        <ol class="list-decimal p-6 space-y-3 text-gray-700">
          <li>
            Basic and Discipline specific knowledge: Apply knowledge of basic
            mathematics, science and engineering fundamentals and engineering
            specialization to solve the engineering problems.
          </li>
          <li>
            Problem analysis: Identify and analyse well-defined engineering
            problems using codified standard methods.
          </li>
          <li>
            Design/ development of solutions: Design solutions for well-defined
            technical problems and assist with the design of systems components
            or processes to meet specified needs.
          </li>
          <li>
            Engineering Tools, Experimentation and Testing: Apply modern
            engineering tools and appropriate technique to conduct standard
            tests and measurements.
          </li>
          <li>
            Engineering practices for society, sustainability and environment:
            Apply appropriate technology in context of society, sustainability,
            environment and ethical practices.
          </li>
          <li>
            Project Management: Use engineering management principles
            individually, as a team member or a leader to manage projects and
            effectively communicate about well-defined engineering activities.
          </li>
          <li>
            Life-long learning: Ability to analyse individual needs and engage
            in updating in the context of technological changes.
          </li>
        </ol>
      ),
    },
    {
      title: "Programme Specific Outcomes",
      content: (
        <ol class="list-decimal ml-6 text-gray-700">
          <li>
            Solve computational problems by applying concepts of programming and
            mathematical foundation.
          </li>
          <li>
            Manage database, web services, computer networks, operating systems,
            computer hardware.
          </li>
          <li>
            Design and develop software by applying concepts of programming and
            software engineering.
          </li>
        </ol>
      ),
    },
    // {
    //   title: "Faculty",
    //   content: (
    //     <div className="min-h-screen py-8">
    //       <h1 className="mb-6 text-2xl font-bold text-center">Faculty List</h1>
    //       <div className="max-w-4xl p-6 mx-auto bg-white shadow-md">
    //         {/* Filter staff based on department 'CSE' */}
    //         {staff
    //           .filter((staffMember) => staffMember.department === "CSE")
    //           .map((staffMember, index) => (
    //             <div
    //               key={staffMember.id}
    //               className="mb-6 p-4 border-b border-gray-200 hover:bg-teal-50 transition duration-200 ease-in-out"
    //             >
    //               <span className="block text-lg font-semibold text-gray-800">
    //                 {index + 1}. {staffMember.name || "-"}
    //               </span>
    //               <div className="flex items-center space-x-4 mt-2">
    //                 <img
    //                   src={staffMember.profilePhoto ? `/api/uploads/staffimages/${staffMember.profilePhoto}` : "/default-profile.jpg"}
    //                   alt={staffMember.name}
    //                   className="w-15 h-15 sm:w-12 sm:h-12 rounded-full shadow-md"
    //                 />
    //                 <div className="text-gray-700">
    //                   <p>
    //                     <strong>Qualification:</strong>{" "}
    //                     {staffMember.Qualification || "-"}
    //                   </p>
    //                   <p>
    //                     <strong>Department:</strong>{" "}
    //                     {staffMember.department || "-"}
    //                   </p>
    //                   <p>
    //                     <strong>Specialization:</strong>{" "}
    //                     {staffMember.Specialization || "-"}
    //                   </p>
    //                   <p>
    //                     <strong>Experience:</strong>{" "}
    //                     {staffMember.Experience || "-"}
    //                   </p>
    //                 </div>
    //               </div>
    //             </div>
    //           ))}
    //         {/* Display a message if no CSE faculty is found */}
    //         {staff.filter((staffMember) => staffMember.department === "CSE").length ===
    //           0 && (
    //             <p className="text-center text-gray-500">No CSE faculty found.</p>
    //           )}
    //       </div>
    //     </div>
    //   ),
    // },

    {
      title: "Faculty",
      content: (
        <div className="min-h-screen py-8 bg-gray-100">
          <h1 className="mb-6 text-2xl font-bold text-center text-gray-800">
            Faculty List
          </h1>
          <div className="max-w-5xl p-6 mx-auto bg-white rounded-lg shadow-lg">
            {/* Filter staff based on department 'CSE' */}
            {staff
              .filter((staffMember) => staffMember.department === "CSE")
              .map((staffMember, index) => (
                <div
                  key={staffMember.id}
                  className="flex flex-col md:flex-row items-start md:items-center space-y-4 md:space-y-0 md:space-x-6 mb-6 p-4 border-b border-gray-200 hover:bg-teal-50 transition duration-200 ease-in-out"
                >
                  {/* Profile Image */}
                  <img
                    src={
                      staffMember.profilePhoto
                        ? `${process.env.REACT_APP_BASE_URL}/api/uploads/staffimages/${staffMember.profilePhoto}`
                        : "/default-profile.jpg"
                    }
                    alt={staffMember.name}
                    className="w-20 h-20 sm:w-24 sm:h-24 rounded-full shadow-md"
                  />
                  {/* Staff Information */}
                  <div className="flex-1 text-gray-800">
                    <p className="text-lg font-semibold">
                      {index + 1}. {staffMember.name || "-"}
                    </p>
                    <p className="text-sm mt-1">
                      <strong>Qualification:</strong>{" "}
                      {staffMember.Qualification || "-"}
                    </p>
                    <p className="text-sm mt-1">
                      <strong>Department:</strong>{" "}
                      {staffMember.department || "-"}
                    </p>
                    <p className="text-sm mt-1">
                      <strong>Specialization:</strong>{" "}
                      {staffMember.Specialization || "-"}
                    </p>
                    <p className="text-sm mt-1">
                      <strong>Experience:</strong>{" "}
                      {staffMember.Experience || "-"}
                    </p>
                  </div>
                </div>
              ))}
            {/* Display a message if no CSE faculty is found */}
            {staff.filter((staffMember) => staffMember.department === "CSE")
              .length === 0 && (
              <p className="text-center text-gray-500">No CSE faculty found.</p>
            )}
          </div>
             
        </div>
      ),
    },

    {
      title: "Admission Criteria",
      content: (
        <div className="w-2/3 p-6">
          <p className="mb-4">It is a full-time regular programme.</p>
          <p className="mb-4">
            Duration of the programme is Three years (six semesters).
          </p>
          <p className="mb-4">Intake capacity is 60 seats.</p>
          <p className="mb-4">Candidate should be M.P. domicile.</p>
          <p className="mb-4">
            Eligibility is 10th exam (Compulsorily with Maths and Science)
            pass-out or equivalent.
          </p>
          <p className="mb-4">
            Entry through Pre Polytechnic Test (PPT) conducted by PEB, Bhopal
            <a
              href="http://www.peb.mp.gov.in"
              target="_blank"
              rel="noopener noreferrer"
              className="text-teal-500 underline"
            >
              {" "}
              (www.peb.mp.gov.in)
            </a>
            and on qualifying exam (10th) basis.
          </p>
          <p className="mb-4">
            Admission through Centralized Online Counseling organized by DTEMP /
            at College Level.
          </p>
          <p className="mb-4">Reservation of seats as per M.P. Govt. Rules.</p>
        </div>
      ),
    },
    // {
    //   title: "Academic Calendar", content: (
    //     <div className="hover:cursor-pointer ml-4">
    //       <a href={<AcadCalendar />}>
    //         Click Here for Academic Calendar</a>
    //     </div>
    //   )
    // },
    {
      title: "Academic Calendar",
      content: (
        <Link to="https://www.rgpvdiploma.in/Academics/Acadmic_calander.aspx">
          <a className="hover:cursor-pointer ml-4">Click Here</a>
        </Link>
      ),
    },
    {
      title: "Schemes/Syllabus",
      content: (
        <Link to="/department/cse/syllabus">
          <a className="hover:cursor-pointer ml-4">Click Here</a>
        </Link>
      ),
    },
    {
      title: "Learning Resources",
      content: (
        <div className="p-6 space-y-3">
          <h1 className="text-xl font-bold bg-teal-500 text-white px-2 py-2">
            E-Learning
          </h1>
          <p className="mt-10 text-xl text-teal-500 font-semibold">
            C/C++ Programming Language
          </p>
          <ul className="list-disc ml-6 ">
            <li>
              <a href="https://isocpp.org/faq" className="hover:text-blue-500">
                Best question bank for C++
              </a>
            </li>
            <li>
              <a
                href="https://www.tutorialspoint.com/cprogramming/cprogramming_tutorial.pdf"
                className="hover:text-blue-500"
              >
                C tutorial
              </a>
            </li>
            <li>
              <a
                href="https://www.codechef.com/ide"
                className="hover:text-blue-500"
              >
                Code, compile and run your program
              </a>
            </li>
            <li>
              <a
                href="https://www.learn-c.org/"
                className="hover:text-blue-500"
              >
                Interactive learning environment
              </a>
            </li>
            <li>
              <a href="https://c-faq.com/" className="hover:text-blue-500">
                Question Library by c-faq.com
              </a>
            </li>
          </ul>

          <p className="mt-4 text-xl text-teal-500 font-semibold">Python</p>
          <ul className="list-disc ml-6">
            <li>
              <a
                href="https://docs.python.org/3/download.html"
                className="hover:text-blue-500"
              >
                Learn Python 3.5.1
              </a>
            </li>
          </ul>

          <p className="mt-4 text-xl text-teal-500 font-semibold">Java</p>
          <ul className="space-y-2 list-disc ml-6">
            <li>
              <a
                href="https://docs.oracle.com/javase/tutorial/java/"
                className="hover:text-blue-500"
              >
                Learn Java
              </a>
            </li>
          </ul>
          <ul>
            <li>
              <a
                href="https://www.learnjavaonline.org/"
                className="hover:text-blue-500"
              >
                Learn Java Online
              </a>
            </li>
          </ul>

          <p className="mt-4 text-xl text-teal-500 font-semibold">Linux OS</p>
          <ul className="list-disc ml-6">
            <li>
              <a
                href="https://help.ubuntu.com/community/UsingTheTerminal"
                className="hover:text-blue-500"
              >
                Learn Ubuntu Commands
              </a>
            </li>
            <li>
              <a
                href="https://tldp.org/LDP/lpg-0.4.pdf"
                className="hover:text-blue-500"
              >
                Linux Programmers Guide
              </a>
            </li>
            <li>
              <a
                href="http://advancedlinuxprogramming.com/downloads.html"
                className="hover:text-blue-500"
              >
                Advance Linux Programming
              </a>
            </li>
            <li>
              <a
                href="http://www.freeos.com/guides/lsst/"
                className="hover:text-blue-500"
              >
                Linux Shell Scripting Tutorial v1.05r3: A Beginners handbook
              </a>
            </li>
          </ul>
          <p className="mt-4 text-xl text-teal-500 font-semibold">
            Competition & Interview
          </p>
          <ul className="list-disc ml-6">
            <li>
              <a
                href="https://www.codechef.com/"
                className="hover:text-blue-500"
              >
                CodeChef
              </a>
            </li>
            <li>
              <a
                href="https://www.geeksforgeeks.org/"
                className="hover:text-blue-500"
              >
                Geeks for Geeks
              </a>
            </li>
            <li>
              <a
                href="https://www.geeksforgeeks.org/quiz-corner-gq/"
                className="hover:text-blue-500"
              >
                Geeks quiz
              </a>
            </li>
            <li>
              <a
                href="https://www.careercup.com/"
                className="hover:text-blue-500"
              >
                Career cup
              </a>
            </li>
            <li>
              <a
                href="https://www.hackerrank.com/"
                className="hover:text-blue-500"
              >
                Hacker rank
              </a>
            </li>
            <li>
              <a
                href="http://cs.nits.ac.in/student-links/www.indiabix.com"
                className="hover:text-blue-500"
              >
                Indiabix
              </a>
            </li>
            <li>
              <a
                href="https://www.careerride.com/"
                className="hover:text-blue-500"
              >
                Career Ride
              </a>
            </li>
            <li>
              <a
                href="https://www.programmerinterview.com/"
                className="hover:text-blue-500"
              >
                Programming Interview
              </a>
            </li>
            <li>
              <a
                href="https://placement.freshersworld.com/placement-papers"
                className="hover:text-blue-500"
              >
                Campus Placement Papers
              </a>
            </li>
          </ul>
        </div>
      ),
    },
    {
      title: "Laboratory Details",
      content: (
        <div className="ml-4">
           <LaboratoryDetails/>
        </div>
      ),
    },
    {
      title: "Department Newsletter",
      content: (
        <div className="ml-4">
          <DeptNewsLetter/>
        </div>
      ),
    },
    {
      title: "Past Workshops/Expert Lectures/Educational Visits/Tours",
      content: (
        <div className="ml-4">
          <a href="">Click Here for Details</a>
        </div>
      ),
    },
    {
      title: "Contact Us",
      content: (
        <div className="ml-4">
          <p>Computer Science</p>
          <p>Head of Department – I/C Mr. Vishwas Bagwaiya</p>
          <p>Mobile – 9827220431</p>
        </div>
      ),
    },
    // Add other sections here
  ];

  const ContainerItem = ({ title, children }) => {
    const [isOpen, setIsOpen] = useState(false);
    const contentRef = useRef(null);

    const toggleContainer = () => {
      setIsOpen(!isOpen);
    };

    return (
      <div className="my-4 border-4 border-teal-500 shadow-md mb-6 rounded-lg">
        <div
          className="flex items-center justify-between p-2 text-xl font-bold text-white bg-teal-500 cursor-pointer"
          onClick={toggleContainer}
        >
          <h2>{title}</h2>
          <span
            className={`transform transition-transform duration-300 ${isOpen ? "rotate-180" : ""
              }`}
          >
            &#9660;
          </span>
        </div>
        <div
          ref={contentRef}
          style={{
            maxHeight: isOpen ? `${contentRef.current.scrollHeight}px` : "0px",
            opacity: isOpen ? "1" : "0",
            transform: isOpen ? "scaleY(1)" : "scaleY(0.9)",
            transition: "all 0.5s ease-in-out",
          }}
          className="overflow-hidden transition-all duration-500 ease-in-out origin-top transform"
        >
          <div className="p-2 text-gray-800 bg-white">{children}</div>
        </div>
      </div>
    );
  };

  return (
    <div className="bg-gray-100 min-h-screen p-2">
      <div className="flex flex-wrap lg:flex-nowrap p-10 gap-8 ">
        <div className="">
          <div>
            <img
              src={deptcse}
              alt="CSE"
              className="w-full shadow-md p-2 border-4 border-teal-500 rounded-lg mb-8" />
          </div>
          <div className="border-4 border-teal-500 rounded-lg p-2">
            <h1 className="text-white bg-teal-500 p-2 font-bold rounded-sm">Vision</h1>
            <div className="mt-2 p-2 text-gray-800">
              <p className="">
                To create competent Women Technocrats in the field of Computer
                Engineering by imparting high-quality Technical Education along
                with soft skills and social values thereby upholding Women
                community in the Society.
              </p>
            </div>
          </div>
          <div className="border-4 border-teal-500 rounded-lg p-2 mt-8">
            <h1 className="text-white bg-teal-500 p-2 font-bold rounded-sm">Mission</h1>
            <div className="mt-2 p-2 text-gray-800">
              <p className="">
                To offer high-quality diploma program through the updated curriculum
                on par with industrial needs to enhance and augment technical skills
                in the field of Computer Engineering.
              </p>
            </div>
            <ul className="list-disc px-8">
              <li>To impart value-based technical education through state-of-the-art infrastructure and innovative faculty.</li>
              <li>To prepare the students towards a professional career and higher education.</li>
              <li>To promote the diploma holders to adapt to rapidly changing technology through the lifelong learning process.</li>
              <li>To inculcate social values and professional ethics for the overall development of the community.</li>
            </ul>
          </div>
          <div className="mt-8">
            {/* Loop through the containers */}
            {containers.map((container, index) => (
              <ContainerItem key={index} title={container.title}>
                {container.content}
              </ContainerItem>
            ))}
          </div>
        </div>
        {/* Right Section: Gallery */}
        <div className="w-full lg:w1/3">
          <SidebarGalleryPage />
        </div>
      </div>
    </div>
  )
}

export default Deptcse;


